define('lib/podio-ui-kit',['require','podio-ui','react','lib/podio-ui/config'],function(require) {
  if (window._podio_ui_kit)
    return window._podio_ui_kit;

  var PodioUI = require('podio-ui');
  var React = require('react');

  var config = require('lib/podio-ui/config');

  window._podio_ui_kit = PodioUI.default(config);

  return window._podio_ui_kit;
});
